import React, { FC, ReactNode } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Button } from "@natera/form";
import { Separator } from "@app/components";
import { LoginMode } from "@app/provider";
import { OneTimeCodeForm } from "@app/pages/public/signIn/oneTimeCode";

const messages = defineMessages({
  oneTimeCodeContinuePassword: {
    id: "oneTimeCodeContinuePassword",
    defaultMessage: "Continue with email and password",
  },
  oneTimeCodeContinueCode: {
    id: "oneTimeCodeContinueCode",
    defaultMessage: "Log in with a one-time code",
  },
});

export interface OneTimeCodeFormConfig {
  onSubmit: (email: string) => void;
  isLoading: boolean;
  errorMessage?: string;
  prefilledEmail?: string;
  usePlusSignInEmailAddress: boolean;
}

export interface LoginModeSwitchProps {
  loginMode: LoginMode;
  onSwitchMode: () => void;
  oneTimeCodeFormConfig: OneTimeCodeFormConfig;
  switchButtonClassName?: string;
  children: ReactNode;
  isOtpVerificationEnabled?: boolean;
  isLoginRedirectPage?: boolean;
}

export const LoginModeSwitch: FC<LoginModeSwitchProps> = ({
  loginMode,
  onSwitchMode,
  oneTimeCodeFormConfig,
  switchButtonClassName,
  children,
  isOtpVerificationEnabled,
  isLoginRedirectPage = false,
}) => {
  const intl = useIntl();
  const isPasswordMode = loginMode === LoginMode.PASSWORD;
  const switchButtonLabel = isPasswordMode
    ? messages.oneTimeCodeContinueCode
    : messages.oneTimeCodeContinuePassword;

  if (!isOtpVerificationEnabled) {
    return (
      <>
        {!isLoginRedirectPage && <Separator />}
        {children}
      </>
    );
  }

  return (
    <>
      <Button
        className={switchButtonClassName}
        type="button"
        outlined
        onClick={onSwitchMode}
      >
        {intl.formatMessage(switchButtonLabel)}
      </Button>
      <Separator />
      {isPasswordMode ? (
        children
      ) : (
        <OneTimeCodeForm
          onSubmit={oneTimeCodeFormConfig.onSubmit}
          isLoading={oneTimeCodeFormConfig.isLoading}
          errorMessage={oneTimeCodeFormConfig.errorMessage}
          prefilledEmail={oneTimeCodeFormConfig.prefilledEmail}
          usePlusSignInEmailAddress={
            oneTimeCodeFormConfig.usePlusSignInEmailAddress
          }
        />
      )}
    </>
  );
};
